import { Tooltip } from '../Tooltip'

const Button = ({
    children,
    className = '',
    type,
    disabled = false,
    ...props
}) => {
    return (
        <button
            disabled={disabled}
            {...props}
            type={type}
            className={`inline-flex items-center justify-center gap-2 rounded-full px-[22px] py-3 text-[14.5px] font-semibold text-white transition-[transform,box-shadow,opacity] duration-150 active:translate-y-[1px] ${className} ${
                disabled
                    ? 'cursor-not-allowed bg-[#E8C9B6] text-white shadow-none'
                    : 'bg-[linear-gradient(90deg,#ED5C2F,#F28230)] shadow-[0_6px_16px_rgba(237,92,47,0.28)] hover:shadow-[0_10px_22px_rgba(237,92,47,0.34)]'
            }`}>
            {children}
        </button>
    )
}

export function Primary({
    children,
    className = '',
    type,
    disabled = false,
    tooltipText = '',
    ...props
}) {
    type = type || 'button'

    if (tooltipText != '') {
        return (
            <Tooltip text={tooltipText}>
                <Button
                    {...{ children, className, type, disabled, ...props }}
                />
            </Tooltip>
        )
    }

    return <Button {...{ children, className, type, disabled, ...props }} />
}
